module.exports = __webpack_public_path__ + "static/media/lights-holiday.84fefaa4.svg";